import React from 'react';
import PropTypes from 'prop-types';

export const AskAISearchLinkTitle = ({ query = '' }) => {
  return (
    <span className="d-flex text-cool-gray-30">
      <b>Ask AI&nbsp;</b>
      <span className="query-text text-start fw-normal">&quot;{query}&quot;</span>
    </span>
  );
};

AskAISearchLinkTitle.propTypes = {
  query: PropTypes.string,
};
